export default function TieredPricingTableRow({attributes, quantity, discount, price, isSelected}) {

    let tdStyles = {};

    if (isSelected) {
        tdStyles = {
            background: attributes.activeTierColor,
            color: "#fff"
        }
    }

    return (
        <tr>
            <td style={tdStyles}>{quantity}</td>
            {
                attributes.showDiscountColumn && <td style={tdStyles}>{discount ? discount + '%' : '-'}</td>
            }
            <td style={tdStyles}>${price}.00</td>
        </tr>
    )
}
